import languages from "@/data/languages.json";

export type FillInTheGapLanguagePage = {
  code: string;
  name: string;
  slug: string;
};

const languageMap = languages as Record<string, string>;

function slugifyLanguageName(value: string): string {
  return value
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/&/g, " and ")
    .replace(/['’]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

function sanitizeCode(value: string): string {
  return value.toLowerCase().replace(/[^a-z0-9]+/g, "-");
}

function buildLanguagePages(): FillInTheGapLanguagePage[] {
  const pages: FillInTheGapLanguagePage[] = [];
  const usedSlugs = new Set<string>();

  for (const [name, code] of Object.entries(languageMap)) {
    let slug = slugifyLanguageName(name);

    if (!slug) {
      slug = sanitizeCode(code);
    }

    if (usedSlugs.has(slug)) {
      slug = `${slug}-${sanitizeCode(code)}`;
    }

    usedSlugs.add(slug);
    pages.push({ name, code, slug });
  }

  return pages;
}

export const fillInTheGapLanguagePages = buildLanguagePages();

export function getFillInTheGapLanguageBySlug(slug: string): FillInTheGapLanguagePage | undefined {
  return fillInTheGapLanguagePages.find((language) => language.slug === slug);
}

export function getDefaultFillInTheGapLanguage(): FillInTheGapLanguagePage {
  return (
    fillInTheGapLanguagePages.find((language) => language.name === "Spanish (Spain)") ??
    fillInTheGapLanguagePages[0]
  );
}
